import React, { useState } from 'react';
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonButton,
  IonItem,
  IonLabel,
  IonChip,
  IonAlert,
  IonThumbnail,
  IonLoading,
  IonFooter,
  IonText
} from '@ionic/react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import * as actionCreator from '../store/actions/orderActions';
import _ from 'lodash';

import FloatingActionButton from '../components/FloatingActionButton';

export const OrderDetailsContainer: React.FC = (props: any) => {
  const { list, inventoryList, onFulfillOrder, onCancelOrder } = props;
  const { id } = useParams();
  const item = _.cloneDeep(_.find(list, { _id: id }));
  const [showAlert1, setShowAlert1] = useState<boolean>(false);
  const [showAlert2, setShowAlert2] = useState<boolean>(false);

  if (!item) {
    return <IonLoading isOpen={true} message={'Please wait...'} />;
  }

  let filteredInvList = [];
  if (inventoryList) {
    try {
      for (let i = 0; i < item.orderItems.length; i++) {
        let foundListItems = inventoryList.filter((invItem: any) =>
          invItem._id.includes(item.orderItems[i].itemId)
        );
        filteredInvList.push({
          ...foundListItems[0],
          orderQuantity: item.orderItems[i].quantity,
        });
      }
    } catch (e) {
      filteredInvList = [{ _id: '', imageURL: '', name: 'none', price: 0 }];
    }
  }

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="dark">
          <IonTitle>{item.customerName}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonItem>
          <IonLabel>
            <IonText color="dark">
              <h2>{item.customerName}</h2>
            </IonText>
            <p>{item.paymentType || 'MPESA'}</p>
            <IonText color="dark">
              <p>{item.customerNumber}</p>
            </IonText>
            <IonText color="dark">
              <p>KES {item.amountPaid}</p>
            </IonText>
          </IonLabel>
          <IonChip
            slot="end"
            color={
              item.cancelled ? 'danger' : item.fulfilled ? 'success' : 'primary'
            }
          >
            {item.cancelled
              ? 'cancelled'
              : item.fulfilled
              ? 'fulfilled'
              : 'pending'}
          </IonChip>
        </IonItem>
        <IonItem>
          <IonLabel className="ion-text-wrap">
            <IonText color="dark">
              <h2>Address</h2>
            </IonText>
            <IonText color="dark">
              <p>{item.deliveryLocation}</p>
            </IonText>
          </IonLabel>
        </IonItem>
        <IonItem>
          <IonLabel>
            <IonText color="dark">
              <p>{item.createdDate || 'No date found'}</p>
            </IonText>           
            {/*item.updatedDate ? <p>updated: {item.updatedDate}</p> : null*/}
          </IonLabel>
        </IonItem>
        <IonItem>
          <IonLabel className="ion-text-wrap">
            <IonText color="dark">
              <h2>Notes</h2>
            </IonText>
            <IonText color="dark">
              <p>{item.orderDetails}</p>
            </IonText>
          </IonLabel>
        </IonItem>

        {filteredInvList.map((invItem: any) => (
          <IonItem key={invItem._id}>
            <IonThumbnail slot="start" border-radius="0">
              <img src={invItem.imageURL} alt="invItem" />
            </IonThumbnail>
            <IonLabel>
              <h4>{invItem.name}</h4>
              <h4>KES {invItem.price}</h4>
            </IonLabel>
            <IonChip slot="end" color="dark">
              {invItem.orderQuantity}
            </IonChip>
          </IonItem>
        ))}

          <IonToolbar style={{marginTop: '10.5vh'}}>
            <IonButton expand="block" onClick={() => setShowAlert1(true)}>
              {item.fulfilled ? 'ITEM RETURNED' : 'ORDER FULFILLED'}
            </IonButton>
            <IonButton
              expand="block"
              color="danger"
              onClick={() => setShowAlert2(true)}>
              {item.cancelled ? 'ORDER NOT CANCELLED' : 'ORDER CANCELLED'}
            </IonButton>
          </IonToolbar>
      </IonContent>
      <IonAlert
        isOpen={showAlert1}
        onDidDismiss={() => setShowAlert1(false)}
        header={`Order ${item.fulfilled ? 'Was Returned?' : 'Is Fulfilled?'}`}
        message={`You are marking this order as ${
          item.fulfilled ? 'returned' : 'fulfilled'
        }`}
        buttons={[
          'No',
          {
            text: 'Yes',
            handler: () =>
              onFulfillOrder({
                _id: id,
                customerName: item.customerName,
                customerNumber: item.customerNumber,
                deliveryLocation: item.deliveryLocation,
                amountPaid: item.amountPaid,
                orderDetails: item.orderDetails,
                channel: item.channel,
                userId: item.userId,
                fulfilled: item.fulfilled,
              }),
          },
        ]}
      />

      <IonAlert
        isOpen={showAlert2}
        onDidDismiss={() => setShowAlert2(false)}
        header={`Order ${item.cancelled ? 'not Cancelled?' : 'Cancelled?'}`}
        message={`You are marking this order as ${
          item.cancelled ? 'not cancelled' : 'cancelled'
        }`}
        buttons={[
          'No',
          {
            text: 'Yes',
            handler: () =>
              onCancelOrder({
                _id: id,
                customerName: item.customerName,
                customerNumber: item.customerNumber,
                deliveryLocation: item.deliveryLocation,
                amountPaid: item.amountPaid,
                orderDetails: item.orderDetails,
                channel: item.channel,
                userId: item.userId,
                cancelled: item.cancelled,
              }),
          },
        ]}
      />
      {/*<FloatingActionButton children={'/editOrder/' + id} />*/}
      <IonFooter>
      </IonFooter>
    </IonPage>
  );
};

const mapStateToProps = (state: any) => {
  return {
    list: state.ordersReducer.list,
    inventoryList: state.inventoryReducer.list,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    onResetStatus: () => dispatch(actionCreator.resetStatus()),
    onFulfillOrder: (payload: {}) =>
      dispatch(actionCreator.fulfillOrder(payload)),
    onCancelOrder: (payload: {}) =>
      dispatch(actionCreator.cancelOrder(payload)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OrderDetailsContainer);
